import React from "react";
import { Input, Button, Flex, Popconfirm, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { MAX_HEADING_LENGTH } from "../../../../../../domain/clinicalForms";
import { useFieldError } from "./ValidationContext";

const SectionHeaderRow = ({
  field,
  onChange,
  onDelete,
  basePath = [],
  embedded = false,
  hasContent = false,
}) => {
  const labelError = useFieldError([...basePath, "label"]);

  const containerStyle = embedded
    ? {
        background: "var(--drf-primary-tint)",
        borderBottom: hasContent
          ? "1px solid var(--drf-primary-border)"
          : "none",
        padding: "8px 12px",
        minHeight: 40,
      }
    : {
        background: "var(--drf-primary-tint)",
        border: labelError.error
          ? "1px solid #ff4d4f"
          : "1px solid var(--drf-primary-border)",
        borderRadius: 6,
        padding: "6px 12px",
        minHeight: 40,
      };

  return (
    <div>
      <Flex align="center" gap={8} style={containerStyle}>
        <span
          style={{
            width: 3,
            height: 14,
            background: "var(--drf-primary)",
            borderRadius: 2,
            display: "inline-block",
          }}
        />
        <Input
          size="small"
          variant="borderless"
          placeholder="Group title"
          value={field.label}
          maxLength={MAX_HEADING_LENGTH}
          showCount
          onChange={(e) => {
            if (labelError.error) labelError.clear();
            onChange({ ...field, label: e.target.value });
          }}
          style={{
            fontWeight: 600,
            flex: 1,
            padding: 0,
            height: 26,
            lineHeight: "26px",
          }}
        />
        <Popconfirm
          title="Delete this group?"
          okText="Delete"
          okButtonProps={{ danger: true }}
          onConfirm={onDelete}
        >
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            style={{ height: 26, width: 26, minWidth: 26 }}
          />
        </Popconfirm>
      </Flex>
      {labelError.error && (
        <Typography.Text
          type="danger"
          style={{
            fontSize: 12,
            display: "block",
            marginLeft: 12,
            marginTop: 2,
            padding: embedded ? "0 12px 4px" : 0,
          }}
        >
          {labelError.error}
        </Typography.Text>
      )}
    </div>
  );
};

export default SectionHeaderRow;
